module.exports = __webpack_public_path__ + "img/feedback.56aab660.svg";